module.exports = __webpack_public_path__ + "static/media/midnight-linkedin.4b8c3eec.svg";